module.exports = __webpack_public_path__ + "assets/img_thrive_market.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/img_thrive_market.jpg
 ** module id = 218
 ** module chunks = 1
 **/